// extracted by mini-css-extract-plugin
module.exports = {"primary":"#00b1a4","white":"#fff"};